export enum OnlineStatusType {
  OFFLINE = 0,
  ONLINE = 1
}
